<template>
	<section class="section login">
		<div class="columns is-centered">
			<div class="column is-6 is-4-fullhd">
				<h4 class="title is-left">{{ $t('Forgot password') }}</h4>
				
				<b-field :type="{ 'is-danger': validation['email']}"
            		:message="validation['email'] && $t('Email is not valid')" 
					:label="$t('E-mail')" 
					label-for="email">
					<b-input
						required
						:placeholder="$t('E-mail')"
						type="email"
						v-model="user.email"
						:counter="10"
						icon="envelope"
						id="email"
					></b-input>
				</b-field>
				
				
				<b-button type="is-primary" @click="resetPassword">{{ $t('RESET MY PASSWORD') }}</b-button>
				<hr>
				<div >
					
					<b-button
						v-if="this.$i18n.locale == 'hu'"
						type="is-primary"
						outlined
						@click="goBack"
						>{{ $t('Go Back') }}</b-button
					>
					<b-button
						v-else
						type="is-primary"
						outlined
						@click="goBack"
						>{{ $t('Go Back') }}</b-button
					>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: 'ForgetPass',
	components: {},
	metaInfo () {
		return {
			title: this.$t("Password reset"),
			meta: [
				{ name: 'robots', content: 'noindex' },
			]
		}
	},
	data() {
		return {
			user: {
				email: '',
				lang: this.$i18n.locale
			},
			validation: {},
		}
	},
	methods: {
		goBack: function () {
			var _this = this
			_this.$router.back();
		},
		resetPassword: function() {
			this.validation= {};
			//reset password form validation


			if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.user.email)) {
				this.validation["email"] = "Error";
			}
			
			
			if(Object.keys(this.validation).length !== 0){
				return;
			}

			//reset password api call

			var _this = this
			this.$http
				.post('/users/forgetPassword', {...this.user, lang: this.$i18n.locale})
				.then((response) => {
					console.log("user/forgetPassword:", response, _this.$socket.id);
				
					_this.$buefy.snackbar.open({
						message: _this.$t('Password reset email sent successfuly'),
						position: 'is-top',
						queue: false,
					})
					console.log('ROUTE', _this.$route)
				})
				.catch((error) => {
					console.log(JSON.stringify(error));
					_this.$buefy.snackbar.open({
						message: _this.$t('Failed password reset'),
						type: 'is-danger',
						position: 'is-top',
						duration: 5000,
						queue: false,
					})
				})
		}
	},
}
</script>
